import { formatCurrency } from '@/services/convert'
import { updateRowStyle, updateMultipleGridRecord } from '@/services/grid'
import { instance, errorService } from '@/services/api'
import { projectAPIs } from '@/services/authConstantsV1'
import { showNotification } from '@/services/calculate'
import { AgGridVue } from 'ag-grid-vue'
import CurrencyRenderer from '@/components/DynamicComponents/Renderers/currencyRenderer'
import CustomFilter from '@/components/DynamicComponents/Renderers/customFilter'
import ToolTipRenderer from '@/components/DynamicComponents/Renderers/tooltipRenderer'
import _ from 'lodash'

export default {
  components: {
    'ag-grid-vue': AgGridVue,
  },
  props: [
    'costDetails',
    'costType',
    'takeoffHeight',
    'indirectCostId',
    'assetId',
    'isArchive',
  ],
  data() {
    return {
      data: [],
      redrawTable: false,
      loading: false,
      gridOptions: {
        suppressCellSelection: true,
        alwaysShowVerticalScroll: true,
        debounceVerticalScrollbar: true,
        alwaysShowHorizontalScroll: true,
        headerHeight: 30,
        rowHeight: 28,
        suppressRowClickSelection: true,
        rowSelection: 'multiple',
        tooltipShowDelay: 0,
        suppressContextMenu: true,
        defaultColDef: {
          suppressMovable: true,
          singleClickEdit: false,
          sortable: true,
          menuTabs: ['filterMenuTab'],
          editable: false,
        },
      },
      columnDefs: null,
      frameworkComponents: null,
      width: '100%',
      height: '21rem',
      selectedRowKeys: [],
      selectedRows: [],
      formatCurrency: formatCurrency,
      pinnedTopRowData: [],
      groups: [],
      visible: false,
      groupDetails: null,
      isRowSelectable: true,
      isValidTakeoff: false,
      checked: false,
    }
  },
  beforeMount() {
    this.loadingConfig()
    this.postSort = rowNodes => {
      const takeoffs = []
      for (let i = 0; i < rowNodes.length; i++) {
        takeoffs.push(rowNodes[i].data)
      }
      this.data = [...takeoffs]
    }
  },
  created() {
    this.$root.$on('hideLoader', this.hideLoader)
  },
  mounted() {
    this.loadingConfig()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.getWindowSize)
  },
  watch: {
    costDetails() {
      this.getData(this.gridOptions)
    },
  },
  methods: {
    loadingConfig() {
      this.frameworkComponents = {
        customFilter: CustomFilter,
        costPriceCellRenderer: CurrencyRenderer,
        toolTipRenderer: ToolTipRenderer,
      }

      this.columnDefs = [
        {
          checkboxSelection: true,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          floatingFilter: false,
          width: 5,
          sortable: false,
          pinned: 'left',
          menuTabs: [],
          hide: this.costType !== 4 || this.isArchive,
        },
        {
          headerName: '',
          field: 'isValidTakeoff',
          hide: true,
        },
        {
          headerName: 'Cost Type',
          field: 'costType',
          headerTooltip: 'Cost Type',
          headerClass: 'header-left',
          cellStyle: { textAlign: 'left' },
          cellRendererParams: {
            searchType: 'string',
          },
          width: 120,
          wrapText: false,
          filter: 'customFilter',
          resizable: true,
          cellRenderer: 'toolTipRenderer',
          hide: this.costType !== 4,
        },
        {
          headerName: 'Contract',
          field: 'contract',
          headerTooltip: 'Contract',
          width: 100,
          wrapText: false,
          filter: 'customFilter',
          cellRendererParams: {
            searchType: 'string',
          },
          resizable: true,
          headerClass: 'header-left',
          cellStyle: { textAlign: 'left' },
          cellRenderer: 'toolTipRenderer',
          hide: this.costType !== 4,
        },
        {
          headerName: 'Cat Code',
          field: 'categoryCode',
          headerTooltip: 'Cat Code',
          width: 100,
          wrapText: false,
          filter: 'customFilter',
          cellRendererParams: {
            searchType: 'string',
          },
          resizable: true,
          headerClass: 'header-left',
          cellStyle: { textAlign: 'left' },
          cellRenderer: 'toolTipRenderer',
          hide: this.costType !== 4,
        },
        {
          headerName: 'Description',
          field: 'takeoff',
          headerTooltip: 'Description',
          cellRendererParams: {
            searchType: 'string',
          },
          width: 300,
          wrapText: false,
          filter: 'customFilter',
          resizable: true,
          cellRenderer: 'toolTipRenderer',
          headerClass: 'header-left',
          cellStyle: { textAlign: 'left' },
        },
        {
          headerName: 'Cost',
          field: 'unitCost',
          headerTooltip: 'Cost',
          cellRenderer: 'costPriceCellRenderer',
          cellRendererParams: {
            searchType: 'string',
          },
          headerClass: 'header-right',
          width: 100,
          wrapText: false,
          filter: 'customFilter',
          resizable: true,
          hide: this.costType === 4,
        },
        {
          headerName: 'Indirect Amount',
          field: 'customIndirect',
          headerTooltip: 'Indirect Amount',
          cellRenderer: 'costPriceCellRenderer',
          cellRendererParams: {
            searchType: 'string',
          },
          headerClass: 'header-right',
          width: 100,
          wrapText: false,
          filter: 'customFilter',
          resizable: true,
          hide: this.costType !== 4,
        },
        {
          headerName:
            this.costType === 4 ? 'Tile/Estimate Group Name' : 'Tile Name',
          field: 'tileName',
          headerTooltip:
            this.costType === 4 ? 'Tile/Estimate Group Name' : 'Tile Name',
          cellRendererParams: {
            searchType: 'string',
          },
          width: 150,
          wrapText: false,
          filter: 'customFilter',
          resizable: true,
          headerClass: 'header-left',
          cellStyle: { textAlign: 'left' },
          cellRenderer: 'toolTipRenderer',
        },
      ]
    },

    getContextMenuItems(params) {
      this.groups = this.groupList
      const record = params.node && params.node.data

      var result = [
        {
          name: 'Create New Group',
          action: () => {
            this.handleOk(record)
          },
          icon: '<i class="fa fa-plus-square-o" />',
          disabled: (record && record.estimateGroupId) || !record,
        },
        {
          name: 'Add to Group',
          icon: '<i class="fa fa-exchange" />',
          disabled:
            (record && record.estimateGroupId) ||
            this.groups.length === 0 ||
            !record,
          subMenu: this.showGroups(this.groups, record),
        },
      ]
      return result
    },

    getData(params) {
      const displayColumns = this.refreshColumns()
      params.api.setColumnDefs(displayColumns)
      params.api.sizeColumnsToFit()
      params.api.setRowData(this.costDetails)
      this.isValidTakeoff = this.costDetails.some(
        i => typeof i.isValidTakeoff !== 'undefined' && !i.isValidTakeoff,
      )
      const element = document.querySelector('#' + 'projectdetails')
      if (element) {
        this.height =
          Math.round(element.getBoundingClientRect().height) -
          126 -
          this.takeoffHeight +
          'px'
      }
    },

    refreshColumns() {
      const displayColumns = this.columnDefs
      displayColumns.map(col => {
        let align = ''
        if (col.cellStyle && col.cellStyle.textAlign) {
          align = col.cellStyle.textAlign
        } else {
          align = 'left'
        }
        if (col.field !== 'action') {
          col.cellStyle = param => updateRowStyle(param, col.field, align)
        }
        if (col.headerName !== 'Action' && col.headerName !== '' && col.headerName) {
          col.filter = 'customFilter'
          col.menuTabs = this.checked ? [] : ['filterMenuTab']
          col.sortable = !this.checked
        }
        col.editable = false
      })
      return displayColumns
    },

    gridSizeChanged(e) {
      const element = document.querySelector('#indirectCostTable')
      if (element) {
        this.gridOptions.api.sizeColumnsToFit()
      }
    },

    onRowSelected(event) {
      const selectedNodes = this.gridOptions.api.getSelectedNodes()
      const selectedData = selectedNodes.map(node => node.data.id)
      this.selectedRowKeys = selectedData
      this.selectedRows = selectedNodes.map(node => node.data)
    },

    onSelectionChanged(event) {
      const selectedNodes = this.gridOptions.api.getSelectedNodes()
      const selectedData = selectedNodes.map(node => node.data.id)
      this.selectedRowKeys = selectedData
      this.selectedRows = selectedNodes.map(node => node.data)
    },

    deleteAllRecord() {
      if (this.selectedRowKeys.length > 0) {
        const that = this
        this.$confirm({
          title: `Are you sure want to delete ${this.selectedRowKeys.length} records?`,
          content: h => (
            <div style="color:red">
              <p>This action will delete all information related these rows.</p>
              <p>Please confirm.</p>
            </div>
          ),
          onOk() {
            that.confirmDelete(null)
          },
        })
      } else {
        showNotification(
          'warning',
          'Cost Details',
          'Please select at least one line item!',
        )
      }
    },

    confirmDelete(record) {
      this.loading = true
      const newData = [...this.data]
      const url = projectAPIs.project.asset.indirectCost.costDetails.delete(
        this.$route.params.id,
        this.assetId,
        this.indirectCostId,
      )
      const ids = record ? [record.id] : this.selectedRowKeys
      instance
        .delete(url, { data: ids })
        .then(response => {
          ids.map(element => {
            const findIndex = newData.findIndex(val => val.id === element)
            if (findIndex > -1) {
              newData.splice(findIndex, 1)
            }
          })
          if (record) {
            this.gridOptions.api.applyTransaction({ remove: [record] })
          } else {
            this.gridOptions.api.applyTransaction({
              remove: this.selectedRows,
            })
          }
          _.get(response.data, 'result', []).forEach(element => {
            const index = newData.findIndex(i => i.id === element.id)
            if (index > -1) {
              newData[index].customIndirect = element.customIndirect
            }
          })
          this.gridOptions.api.redrawRows()
          const itemsToUpdate = updateMultipleGridRecord(
            this.gridOptions,
            newData,
          )
          this.gridOptions.api.applyTransaction({
            update: itemsToUpdate,
          })
          this.gridOptions.api.forEachNodeAfterFilter(node => {
            node.setSelected(false)
          })
          this.data = [...newData]
          this.gridOptions.api.redrawRows()
          this.selectedRowKeys = []
          this.selectedRows = []
          this.loading = false
          this.$emit('updateCostDetails', this.indirectCostId, ids, newData)
        })
        .catch(err => {
          this.loading = false
          errorService(err)
        })
    },

    hideLoader(flag) {
      this.loading = flag
    },

    sortTakeoffs(value) {
      let sort = 'asc'
      let key = 'sequence'
      this.checked = value
      this.gridOptions.columnApi.applyColumnState({
        defaultState: { sort: null },
      })
      this.gridOptions.api.setFilterModel(null)
      if (value) {
        sort = 'asc'
        key = 'isValidTakeoff'
      }
      this.gridOptions.columnApi.applyColumnState({
        state: [
          {
            colId: key,
            sort: sort,
          },
        ],
        defaultState: { sort: null },
      })
      const displayColumns = this.refreshColumns()
      this.gridOptions.api.setColumnDefs(displayColumns)
      this.gridOptions.api.sizeColumnsToFit()
    },

    filterChanged() {
      this.isValidTakeoff = this.data.some(
        i => typeof i.isValidTakeoff !== 'undefined' && !i.isValidTakeoff,
      )
    },
  },
}
